// Internal event bus messages (not analytics events)
// Analytics events for video recording have been moved to centralized @bonusly/analytics AnalyticsEvent.Video namespace
export enum VideoRecordingEvent {
	OpenModal = 'open-video-recording-modal',
	AttachToBonus = 'attach-to-bonus',
	DestroyRecording = 'destroy-recording',
	ClosedCarouselModalWithNoVideo = 'closed-carousel-modal-with-no-video',
}

export enum AudioRecordingEvent {
	OpenModal = 'open-audio-recording-modal',
	AttachToBonus = 'attach-audio-to-bonus',
}
